export const styleVideo = {
    height: '180',
    width: '320',
    playerVars: {
        autoplay: 0,
        controls: 1,
    },
};